<template lang="pug">
  div.image(:class="'image-'+this._uid")
    img(:src="this.payload.url" :alt="this.payload.title" :width="this.imageWidth" :height="this.imageHeight")
</template>

<script>

import Vue from 'vue'

// component instance
var imageBlock = Vue.component('image-block', {
  name: 'imageBlock',
  props: ['payload'],
  data: function () {
    return {}
  },
  watch: {
  },
  methods: {

  },
  computed: {
    imageWidth () {
      let w = this.payload.file.width
      w = this.isRetina ? w / 2 : w

      return w
    },
    imageHeight () {
      let h = this.payload.file.height
      h = this.isRetina ? h / 2 : h

      return h
    },
    isRetina () {
      return this.payload.file.name.match('@2x') !== null || this.payload.title.match('@2x') !== null
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default imageBlock
</script>

<style scoped>
  .image, img{
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/imageBlock.vue